import React, { useEffect, useState, useCallback } from 'react'
import get from 'lodash/get'
import { Box } from 'pcln-design-system'
import { useSelector, useDispatch } from 'react-redux'

import { AdContainer } from '../../containers/ad-container'

import { filterAdId } from '../../constants/constants'
import { updateAirlineFiltersUI } from '@mfs/client/listings-client/reducers/filters/airlinesFilter/airlinesFilter'
import { listingsFilterCall } from '@mfs/client/listings-client/actions/listings'
import { updateAirlineFiltersReq } from '@mfs/client/listings-client/reducers/filters/filterInfo/filterInfo'

const includedAirlineCheck = (airlineCode, airSearchRequestModel) => {
  // Subsequent filtered updates are stored in airSearchRequest
  const includedCarriers = get(airSearchRequestModel, 'filter.sliceFilters[0].includedCarriers', [])

  return includedCarriers.length === 1 && includedCarriers.includes(airlineCode)
}

const getIframeSize = (iframe) => {
  const width = iframe.offsetWidth || Number.parseInt(iframe.getAttribute('width'), 10) || 0
  const height = iframe.offsetHeight || Number.parseInt(iframe.getAttribute('height'), 10) || 0
  return { width, height }
}

const getFilterAdIsVisible = (adId) => {
  const adElement = document.getElementById(adId)
  if (!adElement?.firstChild?.firstChild) return false

  const iframe = adElement.querySelector('iframe')
  if (!iframe) return false

  const { width, height } = getIframeSize(iframe)
  return width > 1 && height > 1
}

function SponsoredFilter(props) {
  const [hasRendered, setHasRendered] = useState(false)

  const {
    pclnBootstrapData,
    adId = filterAdId,
    minScreenSize = 'desktop',
    eventName = 'APPLY_AIR_CARRIER_FILTER',
    className,
    maxWidth,
    minWidth,
    fitWidth,
    isMobile,
    onAdVisible,
    onCarrierSelected,
  } = props
  const activeTabId = useSelector((state) => state.activeTabId)

  const airlines = useSelector((state) => state.airlinesFilter) || []
  const airSearchRequestModel = useSelector((state) => state.airSearchRequestModel) || []

  const dispatch = useDispatch()

  const delayedStateUpdate = useCallback(() => {
    return (...args) => {
      const [payload, meta, airlines] = args
      dispatch(
        updateAirlineFiltersReq({
          payload,
          meta,
          airlines,
          sbsParams: {
            activeTabId,
          },
        })
      )
      dispatch(listingsFilterCall(pclnBootstrapData, 'filter'))
    }
  }, [activeTabId, dispatch, pclnBootstrapData])

  useEffect(() => {
    // Marketing team provides "carrierCode" via this global event
    if (globalThis.PCLN && globalThis.PCLN.pclnEventDispatcher) {
      globalThis.PCLN.pclnEventDispatcher.register(eventName, (data) => {
        let carrierCode = data.carrierCode
        const payload = { value: carrierCode, checked: true }
        onCarrierSelected?.(carrierCode)
        dispatch(
          updateAirlineFiltersUI({
            payload,
            meta: {
              isOnlyClick: true,
            },
          })
        )

        if (!includedAirlineCheck(data.carrierCode, airSearchRequestModel)) {
          delayedStateUpdate()(payload, { isOnlyClick: true }, airlines)
        }
      })

      if (!hasRendered && getFilterAdIsVisible(adId)) {
        setHasRendered(true)
        onAdVisible?.()
      }
    }
  }, [adId, onAdVisible, onCarrierSelected])

  useEffect(() => {
    if (!onAdVisible) return
    const interval = setInterval(() => {
      if (getFilterAdIsVisible(adId)) {
        onAdVisible()
        clearInterval(interval)
      }
    }, 200)
    return () => clearInterval(interval)
  }, [adId, onAdVisible])

  return (
    <Box
      mb={isMobile ? undefined : hasRendered && '8px'}
      maxWidth={maxWidth}
      minWidth={minWidth}
      maxHeight={isMobile ? 20 : undefined}
      overflow={isMobile ? 'hidden' : undefined}
      width={isMobile ? '100%' : undefined}
    >
      <AdContainer
        adId={adId}
        className={className}
        isSticky={false}
        minScreenSize={minScreenSize}
        marginBottom={isMobile ? 0 : hasRendered ? 32 : 0}
        fitWidth={!isMobile && fitWidth}
      />
    </Box>
  )
}

export { SponsoredFilter, includedAirlineCheck }
